var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#162B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.67 26.13C70.21 18.12 57.67 17.95 50 25.63C42.33 17.96 29.79 18.13 22.33 26.13C14.87 34.13 15.77 45.77 23.14 53.14L48.23 78.23C49.21 79.21 50.79 79.21 51.77 78.23L76.86 53.14C84.23 45.77 84.78 33.76 77.67 26.13Z",
    fill: "#E2F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9996 79.34C49.2596 79.34 48.5296 79.06 47.9696 78.5L22.8796 53.41C15.3296 45.86 14.9596 33.51 22.0596 25.88C25.7296 21.94 30.6996 19.72 36.0596 19.63C41.3196 19.54 46.2396 21.48 49.9996 25.11C53.7596 21.48 58.7096 19.54 63.9396 19.63C69.3096 19.73 74.2796 21.95 77.9396 25.88C85.0396 33.5 84.6696 45.85 77.1196 53.41L52.0296 78.5C51.4696 79.06 50.7296 79.34 49.9996 79.34ZM36.4196 20.38C36.2996 20.38 36.1896 20.38 36.0696 20.38C30.9096 20.47 26.1296 22.61 22.5996 26.39C15.7696 33.72 16.1296 45.6 23.3996 52.88L48.4896 77.97C49.3196 78.8 50.6696 78.8 51.4896 77.97L76.5796 52.88C83.8496 45.61 84.2096 33.73 77.3796 26.39C73.8496 22.6 69.0696 20.47 63.9096 20.38C58.7196 20.29 53.8996 22.25 50.2496 25.9L49.9796 26.17L49.7096 25.9C46.1396 22.33 41.4296 20.38 36.3896 20.38H36.4196Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 80C76.0457 80 85 71.0457 85 60C85 48.9543 76.0457 40 65 40C53.9543 40 45 48.9543 45 60C45 71.0457 53.9543 80 65 80Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9098 56.25H68.7598V47.1C68.7598 45.94 67.8198 45 66.6598 45H63.3598C62.1998 45 61.2598 45.94 61.2598 47.1V56.25H52.1098C50.9498 56.25 50.0098 57.19 50.0098 58.35V61.65C50.0098 62.81 50.9498 63.75 52.1098 63.75H61.2598V72.9C61.2598 74.06 62.1998 75 63.3598 75H66.6598C67.8198 75 68.7598 74.06 68.7598 72.9V63.75H77.9098C79.0798 63.75 80.0098 62.81 80.0098 61.65V58.35C80.0098 57.19 79.0798 56.25 77.9098 56.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.417a0b201b52ea942807407cd04b943d.svg";
export { ForwardRef as ReactComponent };